<ng-template #content let-modal>
    <div class="modal-header red">
        <div class="container-fluid">
            <div class="row modal-header-row">
                <img class="modal-icon" src="assets/ico/exclamation-triangle-regular.svg" alt="icon">
                <span class="modal-title" id="modal-basic-title">Error</span>

            </div>
        </div>
    </div>
    <div class="modal-body">
        <div *ngFor="let error of errors, let last = last;">
            <div [class.pb-5]="errors.length > 1 && !last">
                <span *ngIf="error.message" class="error-details"><strong>{{error.message}}</strong></span>
                <span *ngIf="error.details" class="error-secondary-details">{{error.details}}.</span>
                <span *ngIf="!errorsCodesDeletePersonaToManager.includes(error.code) && errorHandle" class="error-secondary-details messaggeErrorList">
                    The resources involved are listed below:
                </span>
                <div *ngIf="errorHandle; else codeNotPresent" class="listScrollable">
                    <ul [ngClass]="errorsCodesDeletePersonaToManager.includes(error.code)? 'listWOPad':'listPad'">
                        <div *ngFor="let person of error.codeArgs">
                            <div
                                *ngIf="person['persona_identifier'] && errorsCodesDeleteManager.includes(error.code); else manager">
                                <li>
                                    <a (click)="getUserProfile(person,error.code)" class="link"> <span
                                            class="error-secondary-details">{{person['persona_name']}}
                                        </span></a> 

                                </li>
                            </div>

                            <ng-template #manager>
                                <div *ngIf="errorsCodesDeletePersonaToManager.includes(error.code); else companyCovers">
                                    <br>
                                    <span class="error-secondary-details">
                                        <a (click)="getUserProfile(person,error.code)" class="link">
                                            {{person['manager_name']}}</a> is defined between
                                        <div *ngIf="person['manager_dates'] && person['manager_dates'].length>0"
                                            class="datesErrors">
                                            <div *ngFor="let date of person['manager_dates']">
                                                {{date.date_start | date:'dd/MM/YYYY'}} and <div
                                                    *ngIf="date.date_end, else currentDate">
                                                    {{date.date_end | date:'dd/MM/YYYY'}}.</div>
                                                <ng-template #currentDate>Current
                                                    Date.
                                                </ng-template>
                                            </div>
                                        </div><br>
                                        It would not cover this record which is defined between {{dateStartCompany |
                                        date:'dd/MM/YYYY'}} and <div *ngIf="dateEndCompany, else dateEnd">
                                            {{dateEndCompany | date:'dd/MM/YYYY'}}</div>
                                        <ng-template #dateEnd>Current Date.
                                        </ng-template>
                                    </span>
                                </div>

                                <ng-template #companyCovers>
                                    <li>
                                        <div
                                            *ngIf="errorsCodesCompanyCoversSections.includes(error.code); else ManagerToPersona">
                                            <span class="error-secondary-details">
                                                <a (click)="getUserProfile(person,error.code)" class="link">
                                                    {{person['section_identifier_source'] | sectionname}}
                                                </a>

                                                    ({{person['section_date_start'] | date:'dd/MM/YYYY'}} - <div
                                                        *ngIf="person['section_date_end'], else currentDate" class="datesErrors">
                                                        {{person['section_date_end'] | date:'dd/MM/YYYY'}})</div>
                                                    <ng-template #currentDate>Current
                                                        Date)
                                                    </ng-template>
                                      

                                            </span>
                                        </div>
                                        <ng-template #ManagerToPersona>
                                            <span class="error-secondary-details">
                                                <a (click)="getUserProfile(person,error.code)" class="link">
                                                    {{person['persona_name']}}
                                                </a>
                                                ({{person['company_profile_date_start'] | date:'dd/MM/YYYY'}} - <div
                                                    *ngIf="person['company_profile_date_end'], else currentDate" class="datesErrors">
                                                    {{person['company_profile_date_end'] | date:'dd/MM/YYYY'}})</div>
                                                <ng-template #currentDate>Current Date)
                                                </ng-template></span>
                                        </ng-template>
                                    </li>
                                </ng-template>
                            </ng-template>

                        </div>
                    </ul>
                </div>
                <ng-template #codeNotPresent class="listScrollable">
                    <div *ngIf="error.codeArgs.length>0">
                        <span class="error-secondary-details">
                            {{stringArgs}}
                        </span>
                    </div>
                </ng-template>
                <span *ngIf="!error.message && !error.details"
                    class="error-details"><strong>{{'modals.error.unknownError' | translate}}</strong></span>
                <span *ngIf="error.errorTraceId" class="error-secondary-details"
                    style="margin-top: 2em;"><strong>{{'modals.error.traceID' | translate}}:
                    </strong>{{error.errorTraceId}}</span>
            </div>

            <ng-template ngFor let-item [ngForOf]="error.validationErrors" let-i="index">
                <div class="validation-error mt-3">
                    <span *ngIf="item.fieldName"> <strong>{{'columnName.' + item.fieldName |
                            translate}}:</strong></span>
                    {{item.message}}
                </div>
            </ng-template>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn modal-btn" (click)="close()">OK</button>
    </div>
</ng-template>